import type { ColumnDef } from '@tanstack/react-table';
import { SortableHeader } from '../shared/SortableHeader';
import { principalIdentifierLabel, resolveIdentifierDisplay } from '../../lib/identifierDisplay';
import type { PrincipalIdentifierLocal } from '../../api/types/PlatformLocal';
import type { TenantUserListItemLocal } from '../../api/types/TenantLocal';

/**
 * DEC-RBAC-079/081 — Columna del IDENTIFICADOR de una tabla de usuarios, compartida por
 * `PlatformTenantUsersTable` (contexto platform) y `ScopedUsersTable` (contexto tenant-admin).
 *
 * Se construye en tiempo de render (no a nivel de módulo) porque depende del `principalIdentifier` del
 * tenant (dato async del hook `useTenantIdentifier` / `useMyTenantIdentifier`). Muestra el identificador
 * PRINCIPAL del tenant (Teléfono si phone-primary, Email si email-primary). La tabla muestra SÓLO el
 * principal — el secundario NO va encimado acá (se ve en el detalle del usuario). La decisión de qué
 * dato es principal vive en `resolveIdentifierDisplay`.
 */
export function buildIdentifierColumn(
    principalIdentifier: PrincipalIdentifierLocal,
): ColumnDef<TenantUserListItemLocal> {
    const label = principalIdentifierLabel(principalIdentifier);
    return {
        id: 'identifier',
        // Ordena/filtra por el dato principal.
        accessorFn: (row) => resolveIdentifierDisplay(row, principalIdentifier).primary,
        header: ({ column }) => <SortableHeader column={column} title={label} />,
        cell: (info) => {
            const { primary } = resolveIdentifierDisplay(info.row.original, principalIdentifier);
            return <span>{primary}</span>;
        },
    };
}
